module.exports = __webpack_public_path__ + "static/media/icon.777338dd.png";